class DomHelper {
    static _parseHTML(html) {
        const tmpDOM = document.implementation.createHTMLDocument();
        tmpDOM.body.innerHTML = html;
        return tmpDOM.body.children;
    }

    static _findParsedHTMLElement(query, parsedHTML) {
        const filteredElement = Array.from(parsedHTML).filter(element => {
            if (element.tagName.toLowerCase() === query) return element;
        });

        return filteredElement[0];
    }

    static _replaceElement(element) {
        const elementClone = element.cloneNode(true);
        return element.parentNode.replaceChild(elementClone, element);
    }

    // Makes use of the MutationObserver Web API
    static _observeElement(
        element,
        aFunction,
        isObserveOnce = true,
        config = { childList: true }
    ) {
        let observanceLimitCount = 0;
        let subscriber = () => {};

        isObserveOnce ? _observeOnce() : _observe();

        const observer = new MutationObserver(subscriber);
        observer.observe(element, config);

        function _observeOnce() {
            subscriber = (mutations, observer) => {
                if (observanceLimitCount === 0) {
                    aFunction();
                    observanceLimitCount++;
                }
            };
        }

        function _observe() {
            subscriber = mutations => {
                for (const mutation of mutations) {
                    aFunction();
                }
            };
        }
    }
}
